import React from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from 'recharts';

const fmt = (n) => new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 }).format(n || 0) + ' €';

export default function FinanceCharts({ timeseries }) {
  const data = (timeseries?.series || []).map(s => ({
    month: s.month,
    Facturation: s.billed,
    Encaissements: s.collected,
    'Coût consulting': s.consulting_cost,
    'Marge mensuelle': s.margin,
  }));

  if (data.length === 0) {
    return (
      <div className="bg-white border border-neutral-200 rounded-lg p-8 text-center text-neutral-400" data-testid="finance-charts-empty">
        Aucune donnée à afficher pour la période sélectionnée.
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4" data-testid="finance-charts">
      <ChartCard title="Facturation mensuelle" color="#2563eb" data={data} dataKey="Facturation" testid="chart-billed" />
      <ChartCard title="Rentrées bancaires mensuelles" color="#059669" data={data} dataKey="Encaissements" testid="chart-collected" />
      <ChartCard title="Frais de consulting (récurrent + ajustements)" color="#dc2626" data={data} dataKey="Coût consulting" testid="chart-consulting" />
      <ChartCard title="Marge mensuelle entreprise" color="#0f172a" data={data} dataKey="Marge mensuelle" testid="chart-margin" highlight />
    </div>
  );
}

const ChartCard = ({ title, color, data, dataKey, testid, highlight }) => (
  <div className={`bg-white border rounded-lg p-4 ${highlight ? 'border-neutral-900 ring-1 ring-neutral-900/10' : 'border-neutral-200'}`} data-testid={testid}>
    <h3 className="font-heading font-semibold text-sm text-neutral-700 mb-2">{title}</h3>
    <ResponsiveContainer width="100%" height={200}>
      <LineChart data={data} margin={{ top: 5, right: 5, bottom: 5, left: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
        <XAxis dataKey="month" tick={{ fontSize: 11 }} />
        <YAxis tick={{ fontSize: 11 }} tickFormatter={(v) => `${(v / 1000).toFixed(0)}k`} />
        <Tooltip formatter={(v) => fmt(v)} labelClassName="text-xs" contentStyle={{ fontSize: 12 }} />
        <Line type="monotone" dataKey={dataKey} stroke={color} strokeWidth={2.5} dot={{ r: 3 }} activeDot={{ r: 5 }} />
      </LineChart>
    </ResponsiveContainer>
  </div>
);
